import Avatar from './Avatar.jsx';

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/index.js